<app-error-banner
  *ngIf="paymentModeError"
  [message]="paymentModeError">
</app-error-banner>

<div class="payment-method-container gap-4 p-3 d-flex flex-column"
     *ngIf="paymentMethods?.length && hasValidPaymentMethods()" >
  <span class="header">Payment Options:</span>
  <div class="gap-4 d-flex flex-column">
    <ng-container *ngFor="let paymentMethod of paymentMethods">
      <ng-container [ngSwitch]="paymentMethod.paymentMode">
        <ng-container *ngSwitchCase="'PAY_NOW'">
          <app-pay-now
            [paymentMethodInfo]="paymentMethod"
            [isSelected]="selectedPaymentMethod === paymentMethod.paymentMode"
            (triggerPacDetailsUpdate) = "handleUpdatePacDetails()"
            [pacDetails]="pacDetails"
            (generateReceipt)="onGenerateReceipt()"
            (cardClick)="onSelectMethod($event)"
          ></app-pay-now>
        </ng-container>
        <ng-container *ngSwitchCase="'CHEQUE'">
          <app-cheque-deposit
            [paymentMethodInfo]="paymentMethod"
            [isSelected]="selectedPaymentMethod === paymentMethod.paymentMode"
            (cardClick)="onSelectMethod($event)"
            [pacDetails]="pacDetails"
            (pacDetailsUpdated) = "onPaymentUpdate($event)"
          ></app-cheque-deposit>
        </ng-container>
        <ng-container *ngSwitchCase="'CREDIT_CARD'">
          <app-credit-debit-card
            [paymentMethodInfo]="paymentMethod"
            [pacDetails]="pacDetails"
            [isSelected]="selectedPaymentMethod === paymentMethod.paymentMode"
            (cardClick)="onSelectMethod($event)"
            [selectedPacCount]="selectedPacCount"
          ></app-credit-debit-card>
        </ng-container>
      </ng-container>
    </ng-container>

    <div class="p-3 my-3" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;" *ngIf="pacDetails.paymentCategory === 'COURT_DEPOSIT'">
      <strong>Note:</strong> If the deposit amount is more than <strong>$10,000</strong>, we encourage payment via
      <strong>PayNow</strong>. PayNow has a maximum daily transaction cap of <strong>$200,000</strong>, subject to the limits
      you or your company have set with your bank. For deposits exceeding these limits, please reach out to the
      <strong>Court Officer</strong> to make special arrangements for your payment.
    </div>

    <div class="d-flex justify-content-end" *ngIf="hasPaidLineItems">
      <button type="button"  class="btn btn-outline generate-receipt-btn"

        (click)="onGenerateReceipt()">Generate Receipt
        <i class="fa-solid fa-file-invoice-dollar ms-2"></i>
      </button>
    </div>
    <div class="d-flex justify-content-end" *ngIf="!hasPaidLineItems">
      <button type="button"  class="btn btn-outline"
              (click)="onBack()">Back
      </button>
    </div>

  </div>
</div>

 <app-custom-modal
  #paymentConfirmationModalRef
  [modalId]="'paymentConfirmationModal'"
  [title]="'Confirmation'"
  [message]= "paymentConfirmationMessage"
  [confirmButtonText]="'OK'"
  [cancelButtonText]="'No'"
  [showConfirmOnly]="true"
  (onCloseModel)="handleConfirmationModalClose($event)"
  (modalHidden)="onConfirmationModalHidden()">
</app-custom-modal>

<app-custom-modal
  #receiptConfirmationModalRef
  [modalId]="'receiptConfirmationModal'"
  [title]="'Confirmation'"
  [message]="receiptConfirmationMessage"
  [confirmButtonText]="'Yes'"
  [cancelButtonText]="'No'"
  [showConfirmOnly]="false"
  (onCloseModel)="handleReceiptModalClose($event)">
</app-custom-modal>


